import { StoryNode } from "../StoryBook/StoryData";
import React from "react";
import { OpenAIChatUI } from "./OpenAIChatUI";

export const OpenAIStories = [
    new StoryNode(
        () => {
            return <OpenAIChatUI></OpenAIChatUI>;
        },

        "Shared",
        "OpenAI",
        "UI"
    ),
    new StoryNode(
        () => {
            return (
                <OpenAIChatUI
                    pretext={"write a "}
                    posttext={"with placeholders for data delimited by [! and !]"}
                    label={"Type of letter"}
                ></OpenAIChatUI>
            );
        },

        "Shared",
        "OpenAI",
        "Pre and Post Text"
    ),

    new StoryNode(
        () => {
            return (
                <OpenAIChatUI
                    pretext={"write a "}
                    label={"Type of letter"}
                ></OpenAIChatUI>
            );
        },

        "Shared",
        "OpenAI",
        "Pre Text"
    ),

    new StoryNode(
        () => {
            return (
                <OpenAIChatUI
                    pretext={"write a "}
                    posttext={"with fields delimited by [! and !]"}
                    label={"Type of letter"}
                    onSelectAnswer={(a) => {
                        console.log(a);
                    }}
                ></OpenAIChatUI>
            );
        },

        "Shared",
        "OpenAI",
        "With Callback"
    ),

    new StoryNode(
        () => {
            return (
                <OpenAIChatUI
                    pretext={"write a regex"}
                    label={"For pattern"}
                    onSelectAnswer={(a) => {
                        console.log(a);
                    }}
                ></OpenAIChatUI>
            );
        },

        "Shared",
        "OpenAI",
        "regex"
    ),

    new StoryNode(
        () => {
            return (
                <OpenAIChatUI
                    initialPrompt={`write json schema for 
                        {
                        "name":"carl",
                        "age":30
                        }
                    
                    `}
                    onSelectAnswer={(a) => {
                        console.log(a);
                    }}
                ></OpenAIChatUI>
            );
        },

        "Shared",
        "OpenAI",
        "initial"
    ),
];
